import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-brand-gray1 text-white',
        brand: 'border-transparent bg-brand-green text-white',
        secondary: 'border-brand-gray4 bg-[#F5F5F5] text-brand-gray2',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'border-brand-gray4 text-brand-gray2 bg-transparent',
        // Status badges
        success: 'border-transparent bg-[#E5F9F7] text-[#0D9488]',
        warning: 'border-transparent bg-[#FFFAE6] text-[#B45309]',
        pending: 'border-transparent bg-[#FFFAE6] text-[#B45309]',
        error: 'border-transparent bg-red-50 text-red-700',
      },
    },
    defaultVariants: {
      variant: 'secondary',
    },
  }
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
